module.exports = __webpack_public_path__ + "media/images/ameliorer-mon-bien-etre-af93a873fea0b3272ed20a94e4b5bfcc.svg";